import { getProtocolLabel } from '~/components/smart-accounts/vesting/VestingBalances'
import { VestingBalance } from '~/components/smart-accounts/vesting/types'
import { TokenMetadata } from '~/hooks/useTokenMetadata'
import { ClaimData, ClaimType } from '~/types'
import { displayBigNumber } from '~/utils/display'

export const buildVestingClaimName = ({
  vestingBalance,
  tokenMetadata,
}: {
  vestingBalance: VestingBalance
  tokenMetadata: TokenMetadata
}) =>
  `Claim ${displayBigNumber(vestingBalance.claimableAmount, {
    displayDecimals: 4,
    tokenDecimals: tokenMetadata.decimals,
    minDisplayDecimals: 0,
  })} ${tokenMetadata.symbol} from ${getProtocolLabel(vestingBalance.protocol)} stream`

export const buildVestingClaimData = ({
  vestingBalance,
  chainId,
  tokenMetadata,
}: {
  vestingBalance: VestingBalance
  chainId: number
  tokenMetadata: TokenMetadata
}): ClaimData => ({
  tokenAddress: tokenMetadata.address,
  tokenAmount: vestingBalance.claimableAmount.toString(),
  protocol: getProtocolLabel(vestingBalance.protocol),
  chainId,
  claimType: ClaimType.Vesting,
})
